import { render } from "./SwitchPage.vue?vue&type=template&id=0808c054&scoped=true"
import script from "./SwitchPage.vue?vue&type=script&lang=js"
export * from "./SwitchPage.vue?vue&type=script&lang=js"

import "./SwitchPage.vue?vue&type=style&index=0&id=0808c054&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0808c054"]])

export default __exports__